import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
// import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

serviceWorkerRegistration.register({
  onUpdate: registration => {
    const userWantsReload = window?.confirm('New service worker detected, reload page?') ?? false
    if (userWantsReload) serviceWorkerRegistration.reloadPage()
  },
  onSuccess: registration => {
    console.log('SW registered', registration)
  },
})
